import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import {defaultRating, defaultRatingSliderValue} from '../../../../../consts';
import { reportAnswers as reportAnswersSelector, updateReportAnswers } from '../../../../../reducers/reportSlice';
import { RatingSlider } from "./RatingSlider";

export default function RatingControl() {
    const reportAnswers = useSelector(reportAnswersSelector);
    const dispatch = useDispatch();
    const ratingText = (!reportAnswers?.rating
        ? ''
        : reportAnswers?.rating < 5
            ? "Not likely: "
            : (reportAnswers?.rating < 8
                ? "Medium: "
                : "Very likely: "));

    useEffect(() => {
        if (!reportAnswers?.rating) {
            dispatch(updateReportAnswers({ ...reportAnswers, rating: defaultRating }))
        }
    }, [])

    return (
        <div className="rating-control">
            <div className="section__header">How likely are you to recommend us?</div>
            {ratingText && <div className="text_default_gray">{ratingText}{reportAnswers?.rating}</div>}
            <RatingSlider
                defaultValue={defaultRatingSliderValue}
                onChange={(e, newValue) => dispatch(updateReportAnswers({ ...reportAnswers, rating: newValue }))}
                min={0}
                max={10}
                step={1}
                valueLabelDisplay="on"
                ownerState={{ value: reportAnswers?.rating }}
            />
        </div>
    )
}